module.exports = __webpack_public_path__ + "img/17.e4456103.webp";